






import exchangeCode from './exchangeCode.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {
    exchangeCode,
  },
})
export default class ExCodePopup extends Vue {
  @Prop() close
  @Prop() code
  @Prop() tips
  closeAll() {
    this.close()
  }
}
